import React from 'react'
import Select from "components/selector"

const options = [
  {
    id: 'all',
    label: 'All Events'
  },
  {
    id: 'upcoming',
    label: 'Upcoming Events'
  },
  {
    id: 'recurring',
    label: 'Recurring Events'
  },
  {
    id: 'past',
    label: 'Past Events'
  },
]

const EventType = ({ classes, eventType, handleTypeChange }) => {
  const [value, setValue] = React.useState(options.find((e) => e.id == eventType));

  const handleChange = (e) => {
    setValue(e)
    handleTypeChange(e.id)
  }

  return (
    <Select
      options={options}
      value={value}
      onChange={handleChange}
      className={{
        select_root: classes.select_root,
        select_list: classes.select_list,
        select_menu: classes.select_menu
      }}
    />
  )
}

export default EventType